import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { useStore } from "../../../../app/stores/store";
import { View, Text } from "@react-pdf/renderer";
import compose from "../../../../app/layout/compose";
import { TicketType } from "../../../../app/models/enums";

interface Props {
  pageBreak: boolean;
  disclaimer: string;
  disclaimerFontSize?: string;
  ticketType?: TicketType;
  technicianNames?: string[];
  increaseAuthorizedBy?: string;
  originalEstimateAmount?: number;
}

export default observer(function DisclaimerMiddlePdfView({
  pageBreak,
  disclaimer,
  disclaimerFontSize,
  ticketType,
  technicianNames,
  increaseAuthorizedBy,
  originalEstimateAmount
}: Props) {
  const { disclaimerStore } = useStore();

  const {
    previewMiddleDisclaimer,
    previewInvoiceMiddleDisclaimer,
    loadSettingDisclaimer,
  } = disclaimerStore;

  useEffect(() => {
    loadSettingDisclaimer();
  }, [loadSettingDisclaimer]);

  return (
    <View
      style={{
        ...compose("view pageWidth borderSolid padding5pxLeft padding5pxRight"),
        height: "58mm",
        maxHeight: "58mm",
        marginTop: "2mm",
      }}
      wrap={false}
      break={pageBreak}
    >
      <Text
        style={{
          ...compose("text "),
          width: "197mm",
          fontSize: disclaimerFontSize ?? "13pt",
          letterSpacing: "0",
        }}
      >
        {
        // eslint-disable-next-line eqeqeq
        ticketType == TicketType.Estimate
          ? previewMiddleDisclaimer(disclaimer)
          : previewInvoiceMiddleDisclaimer(
              disclaimer,
              technicianNames ?? [],
              increaseAuthorizedBy ?? "",
              originalEstimateAmount
            )}
      </Text>
    </View>
  );
});
